import { Box, Skeleton, Table } from '@chakra-ui/react';
import type React from 'react';
import type { DataTableSkeletonProps } from '@/components/Organisms/DataTable/DataTable.types';
import { colors } from '@/components/ui/theme';

const DataTableSkeleton: React.FC<DataTableSkeletonProps> = ({
	rows = 15,
	totalColumns = 8,
	bordered = false,
	size,
	isSelectable = false,
}) => {
	const getRandomWidth = () => {
		const widths = ['40%', '60%', '80%'];
		return widths[Math.floor(Math.random() * widths.length)];
	};
	return (
		<>
			{Array.from({ length: rows }).map((_, rowIndex) => (
				<Table.Row
					key={rowIndex as number}
					bg={{
						base: bordered ? '' : '{colors.gray.50}',
						_dark: colors.tabelCellDark,
					}}
				>
					{Array.from({ length: totalColumns }).map((_, colIndex) => (
						<Table.Cell
							key={colIndex as number}
							p={size}
							borderBottom="1px solid"
							borderColor={{
								base: bordered ? '{colors.gray.200}' : '{colors.gray.50}',
								_dark: bordered ? '{colors.gray.600}' : '{colors.gray.800}',
							}}
						>
							<Box height="1.5rem" display="flex" alignItems="center">
								<Box width="100%">
									<Skeleton
										height="12px"
										variant="shine"
										flex="1"
										width={(isSelectable && colIndex === 1) || (!isSelectable && colIndex === 0) ? '0px' : getRandomWidth()}
										css={{
											'--start-color': {
												base: 'colors.gray.200',
												_dark: 'colors.gray.700',
											},
											'--end-color': { base: '#d4e4e182', _dark: '#47545157' },
										}}
									/>
								</Box>
							</Box>
						</Table.Cell>
					))}
				</Table.Row>
			))}
		</>
	);
};

export default DataTableSkeleton;
